import {AbstractVisualFeature, allVisuals} from '../../visual-feature.js';

import {raceCardFactory} from './race-card.factory.js';

import PALETTE_SCHEMA from './race-card.palette-schema.yaml';

class RaceCardFeature extends AbstractVisualFeature {
    get name() {
        return 'RaceCard';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return raceCardFactory(PALETTE);
    }
}

if (FEATURES.racing || FEATURES.virtuals) {
    // RaceCard used only with racing or virtuals
    // It could be used in event cards carousel, but without racing feature enabled it will lead to nowhere
    new RaceCardFeature(allVisuals);
}
